/* --------- GUIDA ALLE TAGLIE --------- */

function sgInit() {
  document.querySelectorAll('.sg-controls[data-panel]').forEach(function(el) {
    if (el.dataset.initialized) return;
    el.dataset.initialized = 'true';

    var id = el.getAttribute('data-panel');
    el.innerHTML =
      '<div class="sg-toggle">' +
        '<button class="active" onclick="sgUnit(this,\'' + id + '\',\'cm\')">CM</button>' +
        '<button onclick="sgUnit(this,\'' + id + '\',\'in\')">IN</button>' +
      '</div>' +
      '<div class="sg-toggle sg-market-toggle">' +
        ['it','us','eu','fr','uk','aus'].map(function(m) {
          return '<button' + (m === 'it' ? ' class="active"' : '') +
            ' onclick="sgMarket(this,\'' + id + '\',\'' + m + '\')">' + m.toUpperCase() + '</button>';
        }).join('') +
      '</div>';
  });
}

window.sgSubtab = function(btn, id) {
  var section = btn.closest('.sg-section');
  section.querySelectorAll('.sg-subtab-btn').forEach(function(b) { b.classList.remove('active'); });
  section.querySelectorAll('.sg-subtab-panel').forEach(function(p) { p.classList.remove('active'); });
  btn.classList.add('active');
  document.getElementById('sg-' + id).classList.add('active');
};

window.sgSubsubtab = function(btn, parentId, subId) {
  var panel = document.getElementById('sg-' + parentId);
  panel.querySelectorAll('.sg-subsubtab-btn').forEach(function(b) { b.classList.remove('active'); });
  panel.querySelectorAll('.sg-subsubtab-panel').forEach(function(p) { p.classList.remove('active'); });
  btn.classList.add('active');
  document.getElementById('sg-' + parentId + '-' + subId).classList.add('active');
};

window.sgUnit = function(btn, panelId, unit) {
  var wrap = document.getElementById(panelId + '-unit');
  if (wrap) wrap.className = 'sg-unit-' + unit;
  btn.closest('.sg-toggle').querySelectorAll('button').forEach(function(b) { b.classList.remove('active'); });
  btn.classList.add('active');
};

window.sgMarket = function(btn, panelId, market) {
  var panel = document.getElementById(panelId);
  ['it','us','eu','fr','uk','aus'].forEach(function(m) { panel.classList.remove('sg-market-' + m); });
  panel.classList.add('sg-market-' + market);
  btn.closest('.sg-toggle').querySelectorAll('button').forEach(function(b) { b.classList.remove('active'); });
  btn.classList.add('active');
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', sgInit);
} else {
  sgInit();
}